import { render, staticRenderFns } from "./PlantAssetAssignment.vue?vue&type=template&id=37e2aeae"
import script from "./PlantAssetAssignment.vue?vue&type=script&lang=js"
export * from "./PlantAssetAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports